import { GlobalSearchItem } from '../../../../../types/GlobalSearchResponse'

export const formatItemDisplayText = (item: GlobalSearchItem, searchText: string): React.ReactNode => {
  const displayText = item.title + (item.description && ` (${item.description})`)

  if (!searchText.toLocaleLowerCase() || !displayText.toLowerCase().includes(searchText.toLowerCase())) {
    return displayText
  }

  const parts = displayText.split(new RegExp(`(${searchText})`, 'gi'))
  const highlightedText = (
    <>
      {parts.map((part, i) =>
        part.toLowerCase() === searchText.toLowerCase() ? <strong key={i}>{part}</strong> : <span key={i}>{part}</span>
      )}
    </>
  )

  return highlightedText
}
